// Availability schemas (architecture.md §8.3 availability_*).
import { z } from 'zod';
import { hhmm, isoDate, dayOfWeek, timezone } from './common.js';

export const availabilityBreakSchema = z
  .object({ break_start: hhmm, break_end: hhmm })
  .refine((b) => b.break_end > b.break_start, {
    message: 'break_end must be after break_start',
    path: ['break_end'],
  });

export const availabilityRuleSchema = z
  .object({
    day_of_week: dayOfWeek,
    enabled: z.boolean().default(false),
    start_time: hhmm.default('09:00'),
    end_time: hhmm.default('17:00'),
    breaks: z.array(availabilityBreakSchema).max(12).default([]),
  })
  .refine((r) => r.end_time > r.start_time, {
    message: 'end_time must be after start_time',
    path: ['end_time'],
  });

export const availabilityScheduleSchema = z.object({
  name: z.string().trim().min(1).max(80).default('Default'),
  timezone: timezone.default('Asia/Kolkata'),
  is_default: z.boolean().default(true),
  // Exactly 7 rules (one per weekday) is the canonical shape, but accept a subset.
  rules: z.array(availabilityRuleSchema).max(7).default([]),
});

// Per-event availability (Option B). `custom: false` → use the host default schedule;
// `custom: true` → save `rules` onto the event's own dedicated schedule.
export const eventAvailabilitySchema = z.object({
  custom: z.boolean().default(false),
  timezone: timezone.default('Asia/Kolkata'),
  rules: z.array(availabilityRuleSchema).max(7).default([]),
});

export const dateOverrideSchema = z
  .object({
    override_date: isoDate,
    is_unavailable: z.boolean().default(true),
    start_time: hhmm.optional().nullable(),
    end_time: hhmm.optional().nullable(),
  })
  .refine(
    (o) => o.is_unavailable || (o.start_time && o.end_time && o.end_time > o.start_time),
    { message: 'An available override needs start_time < end_time', path: ['end_time'] },
  );
